import { Box, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

const Input = styled("input")({
  display: "none",
});

interface IProps {
  name: string;
  handleOnChange?: any;

}

const FormFileSelect = ({ name, handleOnChange = (x: any) => {} }: IProps) => {
  const { setFieldValue, errors, values }: any = useFormikContext();


  return (
    <>
      <Box sx={{display:"flex", alignItems:"center"}}>
        <label htmlFor="contained-button-file">
          <Input
            accept="image/jpeg,image/gif,image/png,application/,image/x-eps"
            id="contained-button-file"
            type="file"
            name={name}
            onChange={(event: any) => {
              setFieldValue(name, event.target.files[0]);
              handleOnChange(event.target.files[0]);
            }}
          />
          <p style={{ fontSize: "16px" ,fontWeight:"500", color:"#333333", textDecoration:"underline", marginLeft:22, cursor:"pointer",  }}>Upload New Photo</p>
          {/* <Button
            sx={{ fontSize: "14px", backgroundColor:"transparent" ,color:"black", textDecoration:"underline" }}
            variant="contained"
            component="span"
          >
            Upload New Photo
          </Button> */}
        </label>
        <Typography>{values?.profile_picture?.name}</Typography>
      </Box>
      <Typography variant="body2" sx={{ color: "error.main" }}>
        {errors[name] ? errors[name] : ""}
      </Typography>
    </>
  );
};

export default FormFileSelect;
